import { createTheme, ThemeProvider } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
  shape: {
    borderRadius: 8,
  },
  spacing: 6,
  typography: {
    body1: {
      fontSize: "1rem",
    },
  },
  palette: {
    secondary: {
      main: "#eaeaea",
      dark: "#d8d8d8",
    },
    primary: {
      main: "#16ca61",
    },
    success: {
      main: "#16ca61",
    },
  },
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});
export default function RTLProvider({ children }) {
  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </CacheProvider>
  );
}
